/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';


@Injectable({ providedIn: 'root' })
export class CcrRequestFileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ccrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGet()` */
  static readonly CcrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGetPath = '/ccr/file/statement-footer-03934972-8f9c-49dd-8882-cf3fce39c60b.html';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ccrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ccrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGet$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, CcrRequestFileService.CcrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGetPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ccrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ccrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGet(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.ccrFileStatementFooter039349728F9C49Dd8882Cf3Fce39C60BHtmlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ccrFileSimplePdfGet()` */
  static readonly CcrFileSimplePdfGetPath = '/ccr/file/simple.pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ccrFileSimplePdfGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  ccrFileSimplePdfGet$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, CcrRequestFileService.CcrFileSimplePdfGetPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ccrFileSimplePdfGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ccrFileSimplePdfGet(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.ccrFileSimplePdfGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
